/**
 * 「人が配信画面を見に来ている」プレビュー閲覧の判定。
 *
 * 規約 (URL クエリ):
 *   - `?preview=1`                       … 人の閲覧。端末として記録しない (既存)
 *   - `?preview=1&terminalId=<gateway>`  … 指定した配信枠として閲覧する (管理画面のリンク)
 *
 * プレビューは **端末の状態を一切書き換えない** のが約束。具体的には
 *   - heartbeat を送らない (人の閲覧が実機として棚卸しに乗るのを防ぐ)
 *   - localStorage の terminalId / 表示設定キャッシュを書き換えない
 *     (実端末のブラウザで誤って開いても、その端末の設定が壊れない)
 *   - 予約リロード / リリース自己リロードを動かさない
 *
 * Firestore の購読は読み取りのみなので、そのまま行う (配信内容を実物どおり見せる)。
 */

export interface PreviewParams {
  /** プレビュー閲覧として開かれているか */
  enabled: boolean;
  /** 閲覧対象の配信枠 (gateway_id)。未指定ならこの端末自身の設定で見る */
  terminalId: string | null;
}

const currentSearch = (): string => {
  try {
    return window.location.search;
  } catch {
    return "";
  }
};

/** URL クエリからプレビュー指定を読む。テストのため search を差し替えられる。 */
export const readPreview = (
  search: string = currentSearch()
): PreviewParams => {
  try {
    const params = new URLSearchParams(search);
    if (params.get("preview") !== "1") {
      return { enabled: false, terminalId: null };
    }
    const terminalId = (params.get("terminalId") || "").trim();
    return { enabled: true, terminalId: terminalId || null };
  } catch {
    return { enabled: false, terminalId: null };
  }
};

/** プレビュー閲覧か (端末の状態を書き換えてよいかの判断に使う)。 */
export const isPreviewMode = (search?: string): boolean =>
  readPreview(search).enabled;

/** プレビューで見る配信枠。プレビューでない/枠指定なしなら null。 */
export const previewTerminalId = (search?: string): string | null =>
  readPreview(search).terminalId;
